<template>
  <el-dialog :title="titleList[popType]" :visible.sync="formVisible" width="800px" :close-on-click-modal="false" v-if="formVisible">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="110px">
      <el-form-item label="老师姓名：" prop="realName" :class="{'width100': popType!=0}" v-if="[0,1].includes(popType)">
        <el-input v-model="form.realName" placeholder="请输入老师姓名" />
      </el-form-item>
      <el-form-item label="手机号：" prop="mobile" :class="{'width100': popType!=0}" v-if="[0,1].includes(popType)">
        <el-input v-model.number="form.mobile" placeholder="请输入手机号" maxlength="11" />
      </el-form-item>
      <template>
        <el-form-item label="用友编码：" prop="yonYouCode" v-if="popType==0">
          <el-input v-model="form.yonYouCode" placeholder="根据用友返回" disabled />
        </el-form-item>

        <el-form-item label="当前身份：" prop="levelName" v-if="popType==2" class="width100">
          <el-input v-model="form.levelName" disabled />
        </el-form-item>
        <el-form-item :label="popType==0?'身份：':'修改身份：'" :class="{'width100': popType==2}" prop="levelId" v-if="[0,2].includes(popType)">
          <el-select v-model="form.levelId" placeholder="请选择" clearable size="small" @change="handleTechnical(0)">
            <el-option v-for="(item,index) in technicalServiceLevel" :key="item.key" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="popType==6 && form.levelId==1">当前已是最高身份</div>
        <!-- <el-form-item label="当前上级：" prop="parentId" v-if="form.levelId &&form.levelId != 1 && [4,6].includes(popType)" class="width100"> -->
        <el-form-item label="当前上级：" prop="parentId" v-if="[4,6].includes(popType)" class="width100">
          <el-input :value="`${form.parentRealName}(${form.parentLevelName} ${form.parentMobile})`" disabled v-if="form.levelId!=1" />
          <el-input value="" disabled v-else />
        </el-form-item>
        <!-- <el-form-item :label="popType==6?'更换上级：':popType==4?'上级：':'上级身份：'" prop="parentId" v-if="form.levelId && form.levelId != 1 && [0,2,4,6].includes(popType)" class="width100" :rules="[ -->
        <el-form-item :label="popType==6?'更换上级：':popType==4?'上级：':'上级身份：'" prop="parentId" v-if=" [4,6].includes(popType) || ([0,2].includes(popType)  && form.levelId && form.levelId!=1 && form.levelId!=7)" class="width100" :rules="[
      { required: popType!=6, message: '请选择上级身份', trigger: 'change' }]">
          <el-select v-model="form.parentId" placeholder="请选择上级" clearable size="small" @change="changeIdentity" :disabled="popType==6 && (form.levelId==1 || form.levelId==7)" filterable :filter-method="parentFilter" @blur="handleTechnical(1)">
            <el-option v-for="(item,index) in options.identityOptions" :key="item.id" :label="`${item.realName} (${item.mobile})`" :value="item.id"></el-option>
          </el-select>
          <span style="color: #8F8E8E;" v-if="popType==6">不更换上级，系统默认读取原来的上级</span>
        </el-form-item>
        <el-form-item :label="popType==5?'区域：':'管辖区域：'" prop="areaList" class="width100" v-if="[0,3,5].includes(popType) &&(form.levelId==1 || (form.levelId!=1 && form.parentId))" :rules="[
      { required: popType==5, message: '请选择管辖区域', trigger: 'change' }]">
          <el-cascader v-model="form.areaList" :props="cascaderProps" collapse-tags :options="options.technicianAreOptions" clearable popper-class="cascader-box"></el-cascader>
        </el-form-item>
        <el-form-item label="所在区域" prop="addr" class="width100" v-if="[0,1].includes(popType)" :rules="[
        { required: true, message: '请选择所在区域', trigger: 'change' }]">
          <!-- <el-cascader v-model="form.customerAddDTO.addr" :props="cascaderProps1" separator='' collapse-tags
          :options="addressList" clearable disabled></el-cascader> -->
          <el-cascader v-model="form.addr" :props="cascaderProps1" collapse-tags :options="addressList" clearable placeholder="请选择省市区"></el-cascader>
          <!-- <el-cascader v-model="form.areaList" :props="cascaderProps" collapse-tags :options="options.technicianAreOptions" clearable popper-class="cascader-box"></el-cascader> -->
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import technicianInfoApi from '@/api/technical/technicianInfo'
import technicianAreaApi from '@/api/technical/technicianArea'
function initFormBean() {
  const formBean = {
    realName: null,
    mobile: null,
    yonYouCode: '',
    levelId: null,
    parentId: null,
    areaList: [],
    status: 10,
    addr: null
  }
  return formBean
}

export default {
  props: ['technicalServiceLevel', 'popType', 'addressList', 'isServiceTeacher'],
  //popType 0:新增 1:编辑 2:修改身份 3:团队调整-添加老师 4:调整上级 5调整区域 6 设为在职
  data() {
    return {
      titleList: ['添加老师', '编辑老师基础信息', '修改身份', '添加老师', '调整上级', '添加区域', '设为在职身份'],
      isLoading: false,
      options: {
        identityOptions: [],
        technicianAreOptions: []
      },
      form: initFormBean(),
      formVisible: false,
      formRules: {
        realName: [{ required: true, message: '请输入姓名老师', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' },],
        // code: [{ required: true, message: '请输入用友编码', trigger: 'blur' }],
        levelId: [{ required: true, message: '请选择身份', trigger: 'change' }],
        // parentId: [{ required: true, message: '请选择上级身份', trigger: 'change' }],
      },
      cascaderProps: {
        label: 'areaName',
        value: 'areaCode',
        children: 'child',
        multiple: true
      },
      cascaderProps1: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
      }
    }
  },
  created() {
    console.log(1112221,this.popType);
  },
  methods: {
    parentFilter(e) {
      this.handleTechnical(1, e)
    },
    handleTechnical(type, val) {
      if (!type) {
        this.form.parentId = ''
      }
      if (this.form.levelId == 1 || this.form.levelId == 7) return this.changeIdentity()
      //status  10 已入职  20  离职交接  30 已离职
      let { levelId } = this.form;
      let obj = {
        maxLevelId: levelId,
        status: 10,
        pageNo: 1,
        pageSize: 100,
        realName: val
      }
      if (this.isServiceTeacher) obj.levelIsBigCustomer = true
      else obj.levelIsOrdinary = true
      technicianInfoApi.listPageForMini(obj).then(({ data }) => {
        this.options.identityOptions = data.list
        // console.log('data: ',data);
      })
    },
    changeIdentity(type) {
      let { parentId, id, levelId } = this.form;
      let obj = {}
      obj.techInfoId = id || 0
      obj.parentTechInfoId = parentId || 0
      obj.addOrDelete = 1
      obj.v = 3
      obj.customerLeveId = levelId || 0
      if (!this.popType || this.popType == 5) {
        this.loading = this.$loading({
          lock: true,
          text: "加载中",
          background: "rgba(0, 0, 0, 0.7)",
        });
      }
      console.log(1111,this.popType);
      technicianAreaApi.fetchTreeList(obj).then(({ data }) => {
        if (!this.popType || this.popType == 5) { this.loading.close() }
        if (this.popType == 5) {
          this.formVisible = true
        }
        if (data) {
          this.options.technicianAreOptions = this.formatCascaderData(data)
        } else {
          this.options.technicianAreOptions = []
        }
      }).catch(() => {
        this.loading.close();
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(data) {
      this.resetForm()
      this.form = { ...data.row }
      this.popType = data.command
      console.log('this.form: --------', this.form, this.popType, data);
      if ([2, 4, 6].includes(data.command)) {

        //
        if (data.command == 4 || data.command == 6) {
          this.form.parentId = ''
        }
        this.handleTechnical(1)
        // this.form.levelName=this.technicalServiceLevel.find(i=>i.levelId==row.levelId).levelId
        // if(row.levelId!=1){
        //   this.handleTechnical()
        // }

      }
      if ([0, 1].includes(data.command)) {
        this.$set(this.form, 'addr', [data.row.provinceCode, data.row.cityCode, data.row.districtCode])
        // this.form.addr=[data.row.provinceCode,data.row.cityCode,data.row.districtCode]

      }
      if (data.command == 5) {
        this.popType = 5
        this.changeIdentity()
      } else {
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      }
    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.areaList = params.areaList && params.areaList.length > 0 ? params.areaList.map(i => {
        return { provinceCode: i[0], cityCode: i[1], districtCode: i[2], areaType: 3, technicianInfoId: this.form.id }
      }) : null
      return params
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {

          let params = this.calcParams();
          params.parentId = params.parentId ? params.parentId : 0
          if ([0, 1].includes(this.popType)) {
            params.provinceCode = params.addr[0]
            params.cityCode = params.addr[1]
            params.districtCode = params.addr[2]
          }
          // console.log('params: ',params);
          // return
          delete params.addr
          if (params.levelId == 1) {
            params.parentId = 0
          }
          if (this.form.id > 0) {
            if (this.popType == 1) {
              let editParams = {
                id: params.id,
                mobile: params.mobile,
                realName: params.realName,
                yonYouCode: params.yonYouCode,
                cityCode: params.cityCode,
                districtCode: params.districtCode,
                provinceCode: params.provinceCode
              }
              this.isLoading = true
              technicianInfoApi.update(editParams).then((data) => {
                this.postCallback(data)
              }).catch(res => {
                this.isLoading = false
              });
            }
            if (this.popType == 2) {
              let editParams = {
                id: params.id,
                parentId: params.parentId,
                levelId: params.levelId
              }
              this.isLoading = true
              technicianInfoApi.updateLevel(editParams).then((data) => {
                this.postCallback(data)
              }).catch(res => {
                this.isLoading = false
              });
            }
            if (this.popType == 4) {
              let editParams = {
                id: params.id,
                parentId: params.parentId
              }
              this.isLoading = true
              technicianInfoApi.updateParent(editParams).then((data) => {
                this.postCallback(data)
              }).catch(res => {
                this.isLoading = false
              });
            }
            if (this.popType == 5) {
              console.log('params: ', params);
              // return
              this.isLoading = true
              technicianAreaApi.saveBatch(params.areaList).then((data) => {
                this.postCallback(data)
              }).catch(res => {
                this.isLoading = false
              });
            }
            if (this.popType == 6) {
              let editParams = {
                id: params.id
              }
              if (this.form.parentId) {
                editParams.parentId = this.form.parentId
              }
              this.isLoading = true
              technicianInfoApi.onTheJob(editParams).then((data) => {
                this.postCallback(data)
              }).catch(res => {
                this.isLoading = false
              });
            }
          } else {
            this.isLoading = true
            technicianInfoApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
      this.isLoading = false
    },
  }
}
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
// ::v-deep .cascader-box  .el-cascader-panel {
//   background-color: #f5f5f5 !important; /* 背景颜色 */
//   border: 1px solid #e9e9e9 !important; /* 边框样式 */
//   border-radius: 4px !important; /* 边框圆角 */
// }
// ::v-deep .el-cascader__dropdown .el-cascader-panel{
//   background-color: red !important;
// }
</style>
